import { useTracking } from '@change-corgi/core/react/tracking';

import { useAvailablePaymentMethods, usePromotePageState } from 'src/app/pages/promote/pageContext';
import type { SavedPaymentMethodContent } from 'src/app/pages/promote/shared/types';

type Props = {
	setDisplayExperiment: (displayExperiment: boolean) => void;
};

type Result = ModelHookResult<
	{
		savedPaymentMethod: SavedPaymentMethodContent;
	},
	{
		onClickChangePaymentMethod: () => void;
	}
>;

export function useVariant2({ setDisplayExperiment }: Props): Result {
	const { savedPaymentMethods } = useAvailablePaymentMethods();
	const [, { setUsingSavedPaymentMethod }] = usePromotePageState();
	const track = useTracking();

	return {
		data: {
			savedPaymentMethod: savedPaymentMethods[0],
		},
		actions: {
			onClickChangePaymentMethod: () => {
				setUsingSavedPaymentMethod(false);
				void track('pp_change_payment_method', {
					use_saved_payment_method: false,
				});
				setDisplayExperiment(false);
			},
		},
	};
}
